export const unlimitedBannerContent = {
  heading: 'Is it really unlimited?',
  introLine1: "Yep. It's truly unlimited data.",
  introLine2: "Because that's simple, and honest.",
  restrictions: ' No restrictions.',
  caps: ' No speed caps.',
}
